import React from "react";
import { useSelector } from "react-redux";
import { CustomerCard } from "@/react/features/customer/card";
import {
  customerSelector,
  tenantSelector,
} from "@/react/features/customer/customerSlice";
import { useGetProfileQuery } from "@/react/features/vcc/profile/profileApi";
import { useErrorNotification } from "@/react/notifications";
import PageLayout from "@/react/features/styled/PageLayout";

export function VccPage({ children }) {
  const customer = useSelector(customerSelector);
  const tenant = useSelector(tenantSelector);
  const tenantName = tenant?.tenantId;
  const { isFetching, error } = useGetProfileQuery(tenantName);

  useErrorNotification(error);

  return (
    <PageLayout>
      <CustomerCard />
      {!customer && <div>Select a customer</div>}
      {!tenant && <div>Customer has no tenants</div>}
      {isFetching && <div>Tenant Profile is loading...</div>}

      {customer && tenant && !isFetching && !error && children}
    </PageLayout>
  );
}
